import { Box, Heading, HStack, Stack, VStack } from "@chakra-ui/react";
import { useEffect } from "react";

import { ConvertRaffleTicketsBanner } from "./ConvertRaffleTicketsBanner";
import { DailySpinToaster } from "./DailySpin";
import { DailySpinEndedBanner } from "./DailySpinEndedBanner";
import { DailySpinHistory } from "./DailySpinHistory";
import { DailySpinStats } from "./DailySpinStats";
import { Raffle } from "./Raffle/Raffle";

import { DAILY_SPIN_BANNER_ID } from "@/constants/shared";
import { useDailySpinOffchain } from "@/hooks/useDailySpinOffchain";
import { useHomeBanner } from "@/hooks/useHomeBanner";

export const DailySpinDeprecated = () => {
  const { dismissBannerId } = useHomeBanner();
  const { spinHistory, isLoading: isLoadingSpinHistory } =
    useDailySpinOffchain();
  useEffect(() => {
    dismissBannerId(DAILY_SPIN_BANNER_ID);
  }, [dismissBannerId]);

  const dailySpinHistory = (
    <VStack gap={4} alignItems="start" w="full" flex={1}>
      <Box>
        <HStack justifyContent="space-between" w="full" alignItems="center">
          <Heading mt={2} size="2xl">
            My Spins
          </Heading>
        </HStack>
      </Box>
      <DailySpinHistory
        limit={100}
        data={spinHistory ?? []}
        localRecentSpin={null}
        isLoading={isLoadingSpinHistory}
      />
    </VStack>
  );

  return (
    <VStack gap={6} w="full">
      <DailySpinEndedBanner />
      <DailySpinStats />
      <ConvertRaffleTicketsBanner />
      <VStack gap={12} w="full">
        <Stack
          gap={12}
          direction={["column", "column", "column", "column", "row"]}
          w="full"
        >
          <VStack flex={1} alignItems={"start"} gap={6}>
            <Box
              w="full"
              h="full"
              flex={1}
              display="flex"
              flexDirection="column"
              hideBelow="md"
            >
              {dailySpinHistory}
            </Box>
          </VStack>
        </Stack>
        <DailySpinToaster />
      </VStack>
      <Raffle />
    </VStack>
  );
};
